import { gql } from "@apollo/client";export default gql`query orderAggregate($where: subscription_order_bool_exp) {
  orderAggregate: subscription_order_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`;
